import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../components/Login.vue"),
  },

  {
    path: "/",
    redirect: "/orders",
    component: () => import("../views/Home"),
    meta: {
      title: "全部订单",
      requireAuth: true,
    },
    children: [
      {
        path: "/information",
        name: "information",
        meta: {
          title: "知识库",
          requireAuth: true,
        },
        component: () => import("../pages/information/information.vue"),
      },
      {
        path: "/informationCategory",
        name: "informationCategory",
        meta: {
          title: "知识库类目",
          requireAuth: true,
        },
        component: () => import("../pages/information/informationCategory.vue"),
      },
      {
        path: "/payProjects",
        name: "payProjects",
        meta: {
          title: "收费项目配置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/PayProjects"),
      },
      {
        path: "/openApiClients",
        name: "openApiClients",
        meta: {
          title: "API客户端",
          requireAuth: true,
        },
        component: () => import("../components/system/ApiClients.vue"),
      },
      {
        name: "buddleOrder",
        path: "orders/buddleOrder",
        meta: {
          title: "同捆发货",
          requireAuth: true,
        },
        component: () => import("../components/order/buddleOrder/BuddleOrder"),
      },
      {
        name: "buddleOrderDetail",
        path: "orders/buddleOrder/buddleOrderDetail",
        meta: {
          title: "同捆列表详情",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () =>
          import("../components/order/buddleOrder/BuddleOrderDetail"),
      },
      {
        name: "buddleOrderBill",
        path: "orders/buddleOrder/buddleOrderBill",
        meta: {
          title: "同捆账单",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () =>
          import("../components/order/buddleOrder/BuddleOrderBill"),
      },
      {
        name: "materialRecord",
        path: "/configuration/materialRecord",
        meta: {
          title: "物料流水",
          breadNumber: 2,
          requireAuth: true,
        },
        component: () => import("../components/configuration/MaterialRecord"),
      },
      {
        name: "container",
        path: "/container",
        meta: {
          title: "批次表",
          requireAuth: true,
        },
        component: () => import("../components/container/container"),
      },
      {
        path: "/containerBill",
        name: "containerBill",
        meta: {
          title: "账单",
          requireAuth: true,
        },
        component: () => import("../components/container/containerBill"),
      },
      {
        path: "/containerBillDetail",
        name: "containerBillDetail",
        meta: {
          title: "账单",
          requireAuth: true,
        },
        component: () => import("../components/container/containerBillDetail"),
      },

      {
        path: "/InternationalShipping",
        name: "InternationalShipping",
        meta: {
          title: "国际运费配置",
          requireAuth: true,
        },
        component: () =>
          import("../components/configuration/InternationalShipping"),
      },
      {
        path: "/wareMaterials",
        name: "wareMaterials",
        meta: {
          title: "仓储物料配置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/WareMaterials"),
      },
      // homeSwiper
      {
        path: "/homeSwiper",
        name: "homeSwiper",
        meta: {
          title: "首页轮播",
          requireAuth: true,
        },
        component: () => import("../components/configuration/homeSwiper"),
      },
      {
        path: "/userIngredients",
        name: "userIngredients",
        meta: {
          title: "用户辅料配置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/UserIngredients"),
      },
      {
        path: "/customers",
        name: "customers",
        meta: {
          title: "用户列表",
          requireAuth: true,
        },
        component: () => import("../components/customer/Customers"),
      },
      // {
      //     path: '/',
      //     component: () =>
      //         import ('../components/Welcome')
      // },
      {
        path: "/userCapitalRecord",
        name: "userCapitalRecord",
        meta: {
          title: "用户资金明细",
          requireAuth: true,
        },
        component: () => import("../components/capitalRecord/CapitalRecord"),
      },
      {
        path: "/systemCapitalRecord",
        name: "systemCapitalRecord",
        meta: {
          title: "系统资金明细",
          requireAuth: true,
        },
        component: () =>
          import("../components/capitalRecord/SystemCapitalRecord"),
      },
      {
        name: "inBox",
        path: "/inBox",
        meta: {
          title: "收件箱",
          requireAuth: true,
        },
        component: () => import("../components/message/InBox"),
      },
      {
        name: "message",
        path: "/message",
        meta: {
          title: "消息群发",
          requireAuth: true,
        },
        component: () => import("../components/message/message"),
      },
      {
        path: "/outBox",
        name: "outBox",
        meta: {
          title: "发件箱",
          requireAuth: true,
        },
        component: () => import("../components/message/OutBox"),
      },
      {
        path: "/newMessage",
        name: "message",
        meta: {
          title: "消息提醒",
          requireAuth: true,
        },
        component: () => import("../components/newMessage/index"),
      },
      {
        path: "/taobaoPurchaseOrderAddress",
        name: "TaobaoPurchaseOrderAddress",
        meta: {
          title: "地址",
          requireAuth: true,
        },
        component: () => import("../components/authorization/TaobaoPurchaseOrderAddress.vue"),
      },
      {
        path: "/authorize",
        name: "Authorize",
        meta: {
          title: "授权",
          requireAuth: true,
        },
        component: () => import("../components/authorization/Authorize.vue"),
      },
      {
        path: "/bad",
        name: "bad",
        meta: {
          title: "不良售后反馈",
          requireAuth: true,
        },
        component: () => import("../components/bad/Bad"),
      },
      {
        path: "/printList",
        name: "printList",
        meta: {
          title: "打印列表",
          requireAuth: true,
        },
        component: () => import("../components/printList/printList"),
      },
      {
        path: "/problem",
        name: "problem",
        meta: {
          title: "不良件货库",
          requireAuth: true,
        },
        component: () => import("../components/problem/Problem"),
      },
      {
        name: "problemDetail",
        path: "/problem/problemDetail",
        meta: {
          title: "不良件货库详情",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () => import("../components/problem/ProblemDetail"),
      },
      {
        path: "/goods",
        name: "goods",
        meta: {
          title: "商品管理",
          requireAuth: true,
        },
        component: () => import("../components/goods/goodsList"),
      },
      {
        path: "/goodsDetails",
        name: "goodsDetails",
        meta: {
          title: "商品详情",
          requireAuth: true,
        },
        component: () => import("../components/goods/goodsDetails"),
      },
      {
        path: "/ordersgroup",
        name: "ordersgroup",
        meta: {
          title: "订单整合",
          requireAuth: true,
        },
        component: () => import("../components/order/OrdersGroup.vue"),
      },
      {
        path: "/orders",
        name: "orders",
        meta: {
          title: "订单列表",
          requireAuth: true,
        },
        component: () => import("../components/order/Orders"),
      },
      {
        name: "badOrder",
        path: "/badOrder",
        meta: {
          title: "不良订单",
          requireAuth: true,
        },
        component: () => import("../components/order/BadOrder"),
      },
      {
        path: "/rechargeList",
        name: "rechargeList",
        meta: {
          title: "线下充值记录",
          requireAuth: true,
        },
        component: () => import("../components/capitalRecord/RechargeList"),
      },
      {
        path: "/canBoxOrders",
        name: "canBoxOrders",
        meta: {
          title: "可装箱订单",
          requireAuth: true,
        },
        component: () => import("../components/order/CanBoxOrders"),
      },
      {
        name: "boxList",
        path: "/boxList",
        meta: {
          title: "装箱单详情",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () => import("../components/container/BoxList"),
      },
      {
        name: "boxOrderList",
        path: "/boxOrderList",
        meta: {
          title: "箱子详情",
          requireAuth: true,
          breadNumber: 3,
        },
        component: () => import("../components/container/BoxOrderList"),
      },
      {
        name: "orderDetail",
        path: "/orders/orderDetail",
        meta: {
          title: "订单详情",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () => import("../components/order/OrderDetail"),
      },
      {
        name: "bill",
        path: "/orders/bill",
        meta: {
          title: "发送账单",
          requireAuth: true,
          breadNumber: 2,
        },
        component: () => import("../components/order/bill"),
      },
      {
        path: "/adminuser",
        name: "adminuser",
        meta: {
          title: "员工管理",
          requireAuth: true,
        },
        component: () => import("../components/system/UserList"),
      },
      {
        path: "/checkCount",
        name: "checkCount",
        meta: {
          title: "检品统计",
          requireAuth: true,
        },
        component: () => import("../components/system/CheckCount"),
      },
      {
        path: "/sourceEquipment",
        name: "SourceEquipment",
        meta: {
          title: "数据来源统计",
          requireAuth: true,
        },
        component: () => import("../components/system/SourceEquipment"),
      },
      {
        path: "/roles",
        name: "roles",
        meta: {
          title: "角色维护",
          requireAuth: true,
        },
        component: () => import("../components/system/Roles"),
      },
      {
        path: "/menu",
        name: "menu",
        meta: {
          title: "菜单维护",
          requireAuth: true,
        },
        component: () => import("../components/system/Menus"),
      },
      {
        path: "/dictionary",
        name: "dictionary",
        meta: {
          title: "数据字典管理",
          requireAuth: true,
        },
        component: () => import("../components/system/Dictionary"),
      },
      {
        name: "storageOrders",
        path: "/storageOrders",
        meta: {
          title: "仓库保管订单",
          requireAuth: true,
        },
        component: () => import("../components/order/StorageOrders"),
      },
      {
        name: "arrivalOrders",
        meta: {
          title: "到库订单",
          requireAuth: true,
        },
        path: "/arrivalOrders",
        component: () => import("../components/order/ArrivalOrders"),
      },
      {
        path: "/LogisticsCompany",
        name: "LogisticsCompany",
        meta: {
          title: "物流公司配置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/LogisticsCompany"),
      },
      {
        path: "/billingPle",
        name: "billingPle",
        meta: {
          title: "配置国际运费",
          requireAuth: true,
        },
        component: () => import("../components/configuration/billingPle"),
      },
      {
        path: "/tempConfig",
        name: "tempConfig",
        meta: {
          title: "模板配置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/TempConfig"),
      },
      {
        path: "/locator",
        name: "locator",
        meta: {
          title: "库位设置",
          requireAuth: true,
        },
        component: () => import("../components/configuration/Locator"),
      },
      {
        path: "/configAccountNumber",
        name: "configAccountNumber",
        meta: {
          title: "购买账号配置",
        },
        component: () =>
          import("../components/configuration/ConfigAccountNumber"),
      },
      {
        path: "/testnav",
        component: () => import("../components/testnav"),
      },
      {
        path: "/orderStateLog",
        name: "orderStateLog",
        meta: {
          title: "操作记录",
          requireAuth: true,
        },
        component: () => import("../components/system/OrderStateLog"),
      },
      {
        path: "/version",
        name: "version",
        meta: {
          title: "版本列表",
          requireAuth: true,
        },
        component: () => import("../components/version/VersionList"),
      },
      {
        path: "/exchangeRate",
        name: "exchangeRate",
        meta: {
          title: "汇率配置",
          requireAuth: true,
        },
        component: () => import("../components/capitalRecord/ExchangeRate"),
      },
      {
        path: "/shopBlackList",
        name: "shopBlackList",
        meta: {
          title: "商品黑名单",
          requireAuth: true,
        },
        component: () => import("../components/capitalRecord/shopBlackList"),
      },
      {
        path: "/access",
        name: "access",
        meta: {
          title: "出入金统计",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/access"),
      },
      {
        path: "/income",
        name: "income",
        meta: {
          title: "收入统计",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/income"),
      },
      {
        path: "/orderIncome",
        name: "orderIncome",
        meta: {
          title: "订单收入明细",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/orderIncome"),
      },
      {
        path: "/GrossProfitMTD",
        name: "GrossProfitMTD",
        meta: {
          title: "毛利润月报表",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/GrossProfitMTD"),
      },
      {
        path: "/orderBill",
        name: "orderBill",
        meta: {
          title: "订单账单",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/orderBill"),
      },
      {
        path: "/batchIncome",
        name: "batchIncome",
        meta: {
          title: "批次收入明细",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/batchIncome"),
      },
      {
        path: "/orderAmountSummary",
        name: "orderAmountSummary",
        meta: {
          title: "订单金额汇总",
          requireAuth: true,
        },
        component: () => import("../components/Statistics/orderAmountSummary"),
      },
      {
        path: "/transact",
        name: "transact",
        meta: {
          title: "今日待办",
          requireAuth: true,
        },
        component: () => import("../components/transact/Transact"),
      },
      {
        path: "/complaint",
        name: "complaint",
        meta: {
          title: "客户投诉",
          requireAuth: true,
        },
        component: () => import("../components/complaint/Complaint"),
      },
      {
        path: "/configContact",
        name: "configContact",
        meta: {
          title: "联系我们",
          requireAuth: true,
        },
        component: () => import("../components/configContact/ConfigContact"),
      },
      {
        path: "/calendar",
        name: "calendar",
        meta: {
          title: "假期设置",
          requireAuth: true,
        },
        component: () => import("../components/calendar/index"),
      },
      {
        path: "/im",
        name: "Im",
        meta: {
          title: "客服",
          requireAuth: true,
        },
        component: () => import("../components/im/index"),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

//路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === "/login") return next();
  const tokenStr = window.sessionStorage.getItem("token");
  console.log(tokenStr);
  if (!tokenStr) return next("/login");
  next();
});
export default router;
